import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

class Intro extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOADING: 'Y'
        };
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        /*setTimeout(() => {
            this.setState({ LOADING:'N' });
        }, 3000)*/
        this.setState({ LOADING:'N' });
    }
    
    render() { 

        if(this.state.LOADING=='N')
        {
            if(localStorage.getItem('delCIRCLE') && localStorage.getItem('delCIRCLE')!=null)
            {
                return (<Redirect to={'/home'}/>)
            }
        }
    
        const options = {
            items: 1,
            nav: false,
            loop: false,
            dots: true,
        };

        return (
            <div>
                {this.state.LOADING=='Y' && <Loader />}
                {this.state.LOADING=='N' &&
                    <div>
                        <div id="appCapsule" >
                            <div className="carousel-slider owl-carousel owl-theme">
                                <OwlCarousel className="owl-theme" {...options}>
                                    <div className="item p-3">
                                        <h2 className="pb-4">10,000 plus Items onboard</h2>
                                        <img src="/assets/img/products.png" alt="alt" className="imaged w-100 square mb-4" />
                                    </div>
                                    <div className="item p-3">
                                        <h2>More then 50 delivery locations across Goa</h2>
                                        <img src="/assets/img/locations.png" alt="alt" className="imaged w-100 square mb-4" />
                                    </div>
                                    <div className="item p-3">
                                        <h2>Largest collection of brands</h2>
                                        <img src="/assets/img/brands.png" alt="alt" className="imaged w-100 square mb-4" />
                                    </div>
                                </OwlCarousel>
                            </div>
                            <div className="carousel-button-footer">
                                <div className="row">
                                    <div className="col-12 pl-4 pr-4">
                                        <Link to="/map" className="text-upper btn btn-danger square btn-md lt-space1 btn-block skip">Skip</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
      
export default Intro;


// WEBPACK FOOTER //
// ./src/components/Intro.js